module.exports = __webpack_public_path__ + "static/img/sang-pal.51cefa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sang-pal/sang-pal.png
// module id = 8ZwJ
// module chunks = 0